import { EmployeeRole, StatusType, CriterionTypeCode } from "./types";

export type Order = 'asc' | 'desc';

export const renderDate = (timestamp: number) => new Date(timestamp).toLocaleTimeString('ru', {
    day: 'numeric',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
})

export const renderDuration = (timestamp: number) => {
    const length = timestamp/1000;

    const minutes = Math.floor(length / 60 ),
        secondsInt = length - minutes * 60,
        secondsStr = secondsInt.toString(),
        seconds = secondsStr.substr(0, 2)

    return minutes ? minutes + 'min, ' + seconds + ' sec' : seconds + ' sec';
}

export const renderDurationWithDots = (timestamp: number) => {
    const length = timestamp/1000;

    const minutes = Math.floor(length / 60 ),
        secondsInt = length - minutes * 60,
        secondsStr = secondsInt.toString(),
        seconds = secondsStr.substr(0, 2)

    return minutes ? minutes + ':' + seconds : '0:' + seconds;
}

export const renderTags = (tags: string []) => {
    return tags.join(', ')
}

export const translateDaysPrefix = (days: number): string => {
    if (days == 1) {
        return `${days} день`
    }
    else if (days >= 2 && days <= 4) {
        return `${days} дня`
    }
    else {
        return `${days} дней`
    }  
} 


export const getUserRole = (role: EmployeeRole): string => {
    let label = ''
    if (role == 'CONTROL') {
        label = 'Администратор' 
    }
    else if (role == 'OWNER') {
        label = 'Владелец'
    }
    else if (role == 'AUDITOR') {
        label = 'Аудитор'
    }
    else if(role == 'MANAGER') {
        label = 'Владелец'
    }
    else if(role == 'READ_ONLY') {
        label = 'Только чтение'
    }
    return label
}

export const getStatus = (status: StatusType): string => {
    let label = 'Статус'
    if (status == 'ACTIVE') {
        label = 'Активна' 
    }
    else if (status == 'INACTIVE') {
        label = 'Деактивирована'
    }
    return label
}

export const getCriterionTypeCode = (code: CriterionTypeCode): string => {
    let label = 'Тип'
    if (code == 'CUSTOM') {
        label = 'Выбор' 
    }
    else if (code == 'PROHIBITION') {
        label = 'Запрет'
    }
    else if (code == 'REQUIREMENT') {
        label = 'Требование'
    }
    return label
}

export const convertCommaToDot = (str: string, idx: number): string => {
    return str.substr(0,idx) + '.' + str.substr(idx + 1); 
}

export const roundToTwo = (value: number): number => {
    return(Math.round(value * 100) / 100);
}

export const convertCommaToDotAndRoundToTwo = (weight: string): number => {
    const commaIdx = weight.toString().indexOf(',')
        if (commaIdx >= 0) {
            return roundToTwo(
                        parseFloat(
                            convertCommaToDot(weight.toString(), commaIdx)
                        )
                    )
        }
        else {
            return roundToTwo(parseFloat(weight))
        } 
}

export const getFormattedDate = (date: Date) => {
    const YYYY = date.getFullYear()
    const mm = (date.getMonth() + 1) < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
    const dd = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()

    return `${YYYY}-${mm}-${dd}`
}

export const getDateFromDateTimeString = (date: string): string => {
    const arr = date.split('T')
    return arr[0] 
}

export const getTimeFromDateTimeString = (date: string): string => {
    const arr = date.split('T')
    const timeWithSec = arr[1]
    const timeWithSecArr = timeWithSec.split('+')
    return timeWithSecArr[0] 
}